import React, { Component } from 'react';
import { AppsCashCuts, ValidationModal } from '../components';
import { connect } from 'react-redux';
import { DISPATCH_ID, CURRENCY, Datos_Empresa, development, FORMAT_NUMBER } from "../libs/utils/Const";
import $, { isEmptyObject } from 'jquery';
import { ApiClient } from "../libs/apiClient";
import moment from 'moment';
// import { check } from 'prettier';

let apiClient = ApiClient.getInstance();

class CashCutModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filledModel: false,
            blindData: {
                checks: [],
                checksTotal: 0.00,
                cards: [],
                cardsTotal: 0.00,
                transfers: [],
                transfersTotal: 0.00,
                returnsAP: [],
                returnsAPTotal: {
                    Name: 'DEVOLUCIÓN COMO PAGO',
                    Amount: 0,
                    Type: 4
                },
                ins: [],
                insTotal: 0.00,
                outs: [],
                outsTotal: 0.00,
                cash: {
                    Name: 'EFECTIVO',
                    Amount: 0,
                    Type: 0
                },
                creditTotal: 0.00,
                creditNotesTotal: 0.00,
                returns: {
                    Name: 'DEVOLUCIONES',
                    Amount: 0,
                    Type: 4
                },
                collectsTotal: 0.00,
                total: 0.00
            },
            currentCashCut: null,
            cashCutConfirmationMessage: '¿Está seguro que quiere continuar?'
        }
    }

    componentDidMount() {
        $("#cashCutModal").on("shown.bs.modal", () => this.getWorkSession());
        this.closeAction();
    }

    getWorkSession = async () => {
        const { enableSpinner } = this.props;
        if (this.props.showDepositOperations === false) return;

        enableSpinner(true);
        const responseApi = await apiClient.checkWorkSession();
        enableSpinner(false);
        this.setState({ currentCashCut: responseApi?.data || null });
    };

    FillBlindCutModel = async () => {
        const { CashCut } = this.props
        const { blindData } = this.state
        for (let index = 0; index < CashCut.length; index++) {
            const cashCut = CashCut[index];
            if (!cashCut.isHeader) {
                let auxObject = {
                    Name: cashCut.Name,
                    Amount: 0,
                    Type: 0
                }

                if (this.findInName("CHEQUE", cashCut.Name)) {
                    auxObject.Type = 1;
                    blindData.checks.push(auxObject);
                } else if (this.findInName("TARJ", cashCut.Name)) {
                    auxObject.Type = 2;
                    blindData.cards.push(auxObject);
                } else if (this.findInName("TRANSF", cashCut.Name)) {
                    auxObject.Type = 3;
                    blindData.transfers.push(auxObject);
                } else if (!this.findInName("ENTRADA DE EFECTIVO", cashCut.Name) && !this.findInName("SALIDA EFECTIVO", cashCut.Name) && this.findInName("EFECTIVO", cashCut.Name)) {
                    blindData.cash = auxObject;
                }
            }
        }
        await this.setState({
            filledModel: true
        })
    }

    closeAction = () => {
        const { GotoDashboard } = this.props;
        $('#totalModal').on('hidden.bs.modal', function () {
            GotoDashboard();
        });
    };

    findInName(word, name) {
        let response = (name || "").toUpperCase().includes(word)
        return (response)
    }

    PrintCashCut = async (type, paperSize, order, cashCut, title) => {
        const { blindData } = this.state
        const { CloseWorkShift, extraPaymentsCashCut, TotalCashCut, TotalAmountSales, NumVentas, ObjCharge, headerCashCut, moneyEntries, moneyOuts, BlindCutByIdSession } = this.props
        if (Number(title) === 1) {
            const responseClose = await CloseWorkShift(blindData);
            if (!responseClose) return
        };

        let user = JSON.parse(localStorage.getItem('Timbra1currentUser'));
        let checks = [];
        let cards = [];
        let transfers = [];
        let returns = [];
        let cashIns = [];
        let cashOuts = [];
        let cash = "";
        let check = "";
        let credit = "";
        let sale = "";
        let cashIn = "";
        let cashOut = "";
        let collect = "";
        let creditNote = "";
        let returnsT = "";
        let transfer = "";
        let card = "";
        let index1 = 0;
        let index2 = 0;
        let index3 = 0;
        let index4 = 0;
        let index5 = 0;
        let index6 = 0;
        let index7 = 0;

        if (Number(title) === 3) {
            const { blindData } = this.state;

            blindData.checksTotal = this.BlindRecoverTotalOf(BlindCutByIdSession, 1, "");
            blindData.cardsTotal = this.BlindRecoverTotalOf(BlindCutByIdSession, 2, "");
            blindData.transfersTotal = this.BlindRecoverTotalOf(BlindCutByIdSession, 3, "");
            blindData.returnsAPTotal = {
                Name: 'DEVOLUCIÓN COMO PAGO',
                Amount: this.BlindRecoverTotalOf(BlindCutByIdSession, 4, "DEVOLUCIÓN COMO PAGO"),
                Type: 4
            };
            blindData.cash = {
                Name: 'EFECTIVO',
                Amount: this.BlindRecoverTotalOf(BlindCutByIdSession, 0, ""),
                Type: 0
            };
            blindData.returns = {
                Name: 'DEVOLUCIONES',
                Amount: this.BlindRecoverTotalOf(BlindCutByIdSession, 4, "DEVOLUCIONES"),
                Type: 4
            };

            for (let index = 0; index < BlindCutByIdSession.length; index++) {
                if (BlindCutByIdSession[index].type === 1) {
                    blindData.checks[index5] = {
                        Name: (BlindCutByIdSession[index].name).substring(7, 50) || "",
                        Amount: (Number(BlindCutByIdSession[index].amount).toFixed(2)).toString() || "0.00",
                    }
                    index5++
                }
                if (BlindCutByIdSession[index].type === 2) {
                    blindData.cards[index6] = {
                        Name: (BlindCutByIdSession[index].name).substring(16, 50).trim() || "",
                        Amount: (Number(BlindCutByIdSession[index].amount).toFixed(2)).toString() || "0.00",
                    }
                    index6++
                }
                if (BlindCutByIdSession[index].type === 3) {
                    blindData.transfers[index7] = {
                        Name: (BlindCutByIdSession[index].name).substring(8, 50) || "",
                        Amount: (Number(BlindCutByIdSession[index].amount).toFixed(2)).toString() || "0.00",
                    }
                    index7++
                }
            }
        }

        for (let index = 0; index < cashCut.length; index++) {
            if (cashCut[index].Type == -1 && cashCut[index].isHeader == false) {
                credit = (cashCut[index].Amount).toString() || "0.00";
            }
            if (cashCut[index].Type == 0 && cashCut[index].isHeader == false) {
                cash = (Number(cashCut[index].Amount).toFixed(2)).toString() || "0.00";
            }
            if (cashCut[index].Type == 1 && cashCut[index].isHeader == false) {
                checks[index1] = {
                    Account: (cashCut[index].Name).substring(7, 50) || "",
                    Amount: (Number(cashCut[index].Amount).toFixed(2)).toString() || "0.00",
                }
                index1++
            }
            if (cashCut[index].Type == 2 && cashCut[index].isHeader == false) {
                cards[index2] = {
                    Account: (cashCut[index].Name).substring(16, 50).trim() || "",
                    Amount: (Number(cashCut[index].Amount).toFixed(2)).toString() || "0.00",
                }
                index2++
            }
            if (cashCut[index].Type == 3 && cashCut[index].isHeader == false) {
                transfers[index3] = {
                    Account: (cashCut[index].Name).substring(8, 50) || "",
                    Amount: (Number(cashCut[index].Amount).toFixed(2)).toString() || "0.00",
                }
                index3++
            }
            if (cashCut[index].Type == 4 && cashCut[index].isHeader == false && cashCut[index].Name != "DEVOLUCIÓN" && cashCut[index].Amount != 0) {
                returns[index4] = {
                    DocNum: cashCut[index].folio || "",
                    Client: cashCut[index].cardCode || "",
                    Amount: (cashCut[index].Amount).toString() || "0.00",
                }
                index4++
            }
            //   if(cashCut[index].Type==0 && cashCut[index].isHeader==false){
            //     sale= (Number(cashCut[index].Amount).toFixed(2)).toString() || "0.00";          
            //   }
            if (cashCut[index].Type == 1 && cashCut[index].isHeader == true) {
                check = (cashCut[index].Amount).toString() || "0.00";
            }
            if (cashCut[index].Type == 998 && cashCut[index].isHeader == false) {
                cashIn = (cashCut[index].Amount).toString() || "0.00";
            }
            if (cashCut[index].Type == 999 && cashCut[index].isHeader == false) {
                cashOut = (cashCut[index].Amount).toString() || "0.00";
            }
            //   if(cashCut[index].Type==0 && cashCut[index].isHeader==false){
            //     collect= (cashCut[index].Amount).toString() || "0.00";          
            //   }
            if (cashCut[index].Type == 14 && cashCut[index].isHeader == false) {
                creditNote = (cashCut[index].Amount).toString() || "0.00";
            }
            if (cashCut[index].Type == 4 && cashCut[index].isHeader == true) {
                returnsT = (cashCut[index].Amount).toString() || "0.00";
            }
            if (cashCut[index].Type == 3 && cashCut[index].isHeader == true) {
                transfer = (Number(cashCut[index].Amount).toFixed(2)).toString() || "0.00";
            }
            if (cashCut[index].Type == 2 && cashCut[index].isHeader == true) {
                card = (Number(cashCut[index].Amount).toFixed(2)).toString() || "0.00";
            }
        }
        this.BlindCashcut()
        let data = {
            Config: {
                TicketType: type,
                PaperSize: paperSize
            },
            Store: {
                Name: Datos_Empresa.Nombre,
                Address: user.Branch.Address || "",
                RFC: user.Timbra.RFC || "",
                Phone: user.Branch.Phone || "",
                Logo: "",
                Footer: "",
                Consecutive: ""
            },
            BusinessPartner: {
                CardCode: "",
                CardName: "",
                RFC: "",
                Regime: "",
                Phone: user.Partner.Phone1 || "",
                AddressInvoice: "",
                AddressDelivery: ""
            },
            OrderSale: {
                DocNum: "",
                DocDate: "",
                DocOrigen: "",
                Seller: "",
                Cashier: user.USER_CODE || "",
                DocTotal: "",
                Subtotal: "",
                TaxTotal: "",
                TaxRate: "",
                DocCur: "",
                Items: [] || "",
                Payments: [] || ""
            },
            CashCut: {
                Type: title === 0 ? "CORTE PARCIAL" : "CORTE TOTAL",
                DocNum: "",
                DocDate: moment(headerCashCut.docUpdate || new Date()).format('DD-MM-YYYY') + "  " + (headerCashCut.endSession !== '' ? moment(headerCashCut.endSession).add(6, "hours").format('LTS') : moment(new Date()).format('LTS')) || "",
                Cashier: headerCashCut.U_NAME || user.USER_CODE || "",
                DocTotal: (Number(TotalCashCut).toFixed(2)).substring() || "0.00",
                BlindTotal: (Number(blindData.total || BlindCutByIdSession.total || "0.00").toFixed(2)).substring(),
                DocCur: "MX",
                NumSales: "",
                NumReturns: "",
                NumCollects: "",
                // TotalSale: (Number(TotalAmountSales).toFixed(2)).substring() || "0.00",
                TotalCash: cash,
                TotalReturn: extraPaymentsCashCut && !!extraPaymentsCashCut.negativeReturns ? (Number(extraPaymentsCashCut.negativeReturns).toFixed(2)).substring() : "0.00",
                // TotalCashIn: (Number(moneyEntries.total).toFixed(2)).toString(),
                // TotalCashOut: (Number(moneyOuts.total).toFixed(2)).toString(),
                TotalCard: card,
                TotalTransfer: transfer,
                TotalCheck: check,
                TotalReturnAsPayment: returnsT || "0.00",
                // TotalCredit: extraPaymentsCashCut.credit || "0.00",
                // TotalCreditNote: extraPaymentsCashCut.creditNotes || "0.00",
                TotalCollect: ObjCharge.Charge || "0.00",
                // CashIns: cashIns,
                // CashOuts: cashOuts,
                Cards: cards,
                Transfers: transfers,
                Checks: checks,
                ReturnsAsPayment: returns,
                Returns: [],
                // Credits:[],
                // CreditNotes:[]
            },
            BlindCashcut: {
                checks: blindData.checks || [],
                checksTotal: (Number(blindData.checksTotal).toFixed(2)).substring() || "0.00",
                cards: blindData.cards || [],
                cardsTotal: (Number(blindData.cardsTotal).toFixed(2)).substring() || "0.00",
                transfers: blindData.transfers || [],
                transfersTotal: (Number(blindData.transfersTotal).toFixed(2)).substring() || "0.00",
                returnsAP: blindData.returnsAP || [],
                returnsAPTotal: (Number(blindData.returnsAPTotal.Amount).toFixed(2)).substring() || "0.00",
                // ins: blindData.ins || [],
                // insTotal: blindData.insTotal || "",
                // outs: blindData.outs || [],
                // outsTotal: blindData.outsTotal || "",
                cash: (Number(blindData.cash.Amount || "0.00").toFixed(2)).substring(),
                // creditTotal: blindData.creditTotal || "",
                // creditNotesTotal: blindData.creditNotesTotal || "",
                returnsTotal: (Number(blindData.returns.Amount || "0.00").toFixed(2)).substring(),
                // collectsTotal: (Number(blindData.collectsTotal).toFixed(2)).substring() || "0.00",
                total: (Number(blindData.total || "0.00").toFixed(2)).substring()
            }
        }

        data.Store.Logo = development == true ? "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"
            : Datos_Empresa.LogoBase64;

        let print = await apiClient.PrintDocuments(data);

    };

    IsOpen(idList, idHeader) {
        let elm = document.getElementById(idList);
        let icon = document.querySelector(`#` + idHeader + ` .fa`);
        if (elm.className == 'collapse show') {
            icon.classList.remove('fa-angle-up');
            icon.classList.add("fa-angle-down");
            return true
        } else {
            icon.classList.remove('fa-angle-down');
            icon.classList.add("fa-angle-up");

            return false
        }
    }


    //#region ########## ONCHANGE FIELDS ########################################################
    OnchangeChecks = (value, index) => {
        const { blindData } = this.state;
        blindData.checks[index].Amount = Number(value);
        blindData.checksTotal = (Number(this.TotalOf(blindData.checks)).toFixed(2)).substring();
        this.setState({ blindData });
    }

    OnchangeCards = (value, index) => {
        const { blindData } = this.state;
        blindData.cards[index].Amount = Number(value);
        blindData.cardsTotal = (Number(this.TotalOf(blindData.cards)).toFixed(2)).substring();
        this.setState({ blindData });
    }

    OnchangeTransfers = (value, index) => {
        const { blindData } = this.state;
        blindData.transfers[index].Amount = Number(value);
        blindData.transfersTotal = (Number(this.TotalOf(blindData.transfers)).toFixed(2)).substring();
        this.setState({ blindData });
    }

    OnchangeCash = (value) => {
        const { blindData } = this.state;
        blindData.cash.Amount = Number(value);
        this.setState({ blindData })
    }

    TotalOf(array) {
        let sum = 0;
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            sum += element.Amount
        }
        return sum
    }

    BlindRecoverTotalOf(array, type, name) {
        let sum = 0;
        let element = 0;
        for (let index = 0; index < array.length; index++) {
            if (type == array[index].type && type != 4) {
                element = array[index].amount;
                sum += element
            }
            if (name == array[index].name && type == 4) {
                element = array[index].amount;
                sum += element
            }
        }
        return sum
    }

    OnchangeReturnsTotal = (value) => {
        const { blindData } = this.state;
        blindData.returns.Amount = Number(value);
        this.setState({ blindData })
    }

    //#endregion


    OnchangeReturnsAP = (value) => {
        const { blindData } = this.state;
        blindData.returnsAPTotal.Amount = Number(value);
        this.setState({ blindData });
    }

    OnchangeIns = (value, index) => {
        const { blindData } = this.state;
        blindData.ins[index] = value;
        blindData.insTotal = this.TotalOf(blindData.ins);
        this.setState({ blindData });
    }

    OnchangeOuts = (value, index) => {
        const { blindData } = this.state;
        blindData.outs[index] = value;
        blindData.outsTotal = this.TotalOf(blindData.outs);
        this.setState({ blindData });

    }


    OnchangeCreditTotal = (value) => {
        const { blindData } = this.state;
        blindData.creditTotal = value;
        this.setState({ blindData })
    }

    OnchangeCreditNotes = (value) => {
        const { blindData } = this.state;
        blindData.creditNotesTotal = value;
        this.setState({ blindData })
    }

    OnchangeCollectsTotal = (value) => {
        const { blindData } = this.state;
        blindData.collectsTotal = value;
        this.setState({ blindData })
    }

    BlindCashcut() {

        const { blindData } = this.state;
        let total = 0;
        total = Number(blindData.returnsAPTotal.Amount) + Number(blindData.transfersTotal) + Number(blindData.cardsTotal) + Number(blindData.checksTotal) + Number(blindData.cash.Amount)
        total = Number(total) - Number(blindData.returns.Amount);

        blindData.total = total
        return total;
    }

    transferName(Name = '') {
        if (!Name) return '';

        const parts = Name?.trim()?.split(/\s+/) || '';
        if (
            parts?.length >= 2 &&
            ['TRASFERENCIA', 'TRANFERENCIA', 'TRANSFERENCIA', 'TRASNFERENCIA']?.includes(parts?.[0]?.toUpperCase())
        ) {
            return parts?.slice(1)?.join(' ');
        }

        return Name;
    }

    OpenCashCutConfirmation = () => {
        $('#cashCutModal').modal('hide');
        $('#vmCashCut').modal('show');
    };

    ValidatePendingPayments = async () => {
        const { currentCashCut, } = this.state;
        const { enableSpinner, notificationReducer: { showAlert }, } = this.props;
        const idWorkShift = currentCashCut?.idSession;

        if (!idWorkShift) {
            return {
                valid: false,
                hasPendingPayments: false,
                hasPendingCashCutVoucher: false,
            };
        }

        try {
            enableSpinner(true);
            const responseApi = await apiClient.getPendingPaymentsBySession({
                idWorkShift
            });

            if (responseApi?.status !== 1) {
                showAlert({ type: 'error', message: responseApi?.message || 'No fue posible validar los documentos pendientes' });

                return {
                    valid: false,
                    hasPendingPayments: false,
                    hasPendingCashCutVoucher: false,
                };
            }

            const { pendingDocuments = [], pendingCashCutVoucherList = [] } = responseApi?.data || {};
            const hasPendingPayments = pendingDocuments?.length > 0;
            const hasPendingCashCutVoucher = pendingCashCutVoucherList?.length > 0;

            if (hasPendingPayments) {
                showAlert({ type: 'warning', message: 'Tiene documentos pendientes por cobrar. Debe ir a pagarlos antes de cerrar el corte.', timeOut: 10000 });
            }

            return {
                valid: true,
                hasPendingPayments,
                hasPendingCashCutVoucher
            };
        } catch (error) {
            console.error('ValidatePendingPayments -> ', error);

            showAlert({ type: 'error', message: 'No fue posible validar los documentos pendientes' });
            return {
                valid: false,
                hasPendingPayments: false,
                hasPendingCashCutVoucher: false,
            };
        } finally {
            enableSpinner(false);
        }
    };

    HandleRealizar = async () => {
        const { notificationReducer: { showAlert }, } = this.props;
        const validation = await this.ValidatePendingPayments(); // Revisar si de las facturas del corte tienen pendientes sus pagos o operaciones a las que no se le ha realizado la vuelta de efeectivo

        if (!validation.valid) {
            return;
        }

        if (validation?.hasPendingCashCutVoucher) {
            showAlert({ type: 'warning', message: 'Tiene operaciones de efectivo pendientes de dar vuelta por lo que no es posible cerrar el corte actual', timeOut: 12000 });
            return; // 117> descometar
        }

        this.setState(
            {
                cashCutConfirmationMessage: validation.hasPendingPayments
                    ? 'Tiene documentos pendientes por cobrar. Debe ir a pagarlos antes de cerrar el corte. ¿Desea continuar de todos modos?'
                    : '¿Está seguro que quiere continuar?'
            },
            this.OpenCashCutConfirmation
        );
    };

    ConfirmCashCutAction = async () => {
        const { _user, CashCut } = this.props;
        await this.PrintCashCut('Corte', '80', _user, CashCut, 1);
    };

    render() {
        const {
            CashCut,
            TotalCashCut,
            ShowCashCutModal,
            lastDaySession,
            HideTotalCashCutsActions,
            _user,
            headerCashCut,
            blindCashCut,
            bankOptions = [],
        } = this.props;
        const { blindData, filledModel, currentCashCut } = this.state

        if (Array.isArray(CashCut) && !filledModel) {
            this.FillBlindCutModel();
        }

        let user = JSON.parse(localStorage.getItem('Timbra1currentUser'));
        const totalFISE = Array.isArray(CashCut) ? CashCut.filter(({ Type }) => Number(Type) === 124).reduce((acc, { Amount }) => acc + Amount, 0) : 0;
        const totalQR = Array.isArray(CashCut) ? CashCut.filter(({ Type }) => Number(Type) === 125).reduce((acc, { Amount }) => acc + Amount, 0) : 0;
        return (
            <div>
                <div className="modal fade " id="cashCutModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="cashCutModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" >
                        <div className="modal-content">
                            <div className="modal-body" style={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 0 }}>
                                <section>
                                    <ul className="nav nav-tabs pl-3 " id="myTab" role="tablist">
                                        {!!HideTotalCashCutsActions && HideTotalCashCutsActions === true
                                            ?
                                            ""
                                            :
                                            <li className="nav-item waves-effect waves-light">
                                                <a className="nav-link active" id="general-tab" data-toggle="tab" href="#general" role="tab" aria-controls="general" aria-selected="false"><h5>Corte Parcial</h5></a>
                                            </li>
                                        }
                                        <li className="nav-item waves-effect waves-light">
                                            <a className="nav-link" id="ventas-tab" data-toggle="tab" href="#ventas" role="tab" aria-controls="ventas" aria-selected="false"><h5>Corte Total</h5></a>
                                        </li>
                                        {/* 
                                        <div className='text-right mr-2'>
                                            <button className="btn" onClick={ShowBlindCashCut}>
                                                <i className={blindCashCut ? "fa fa-eye" : "fa fa-eye-slash"} aria-hidden="true" style={{ fontSize: "25px", color: "#80808073" }}></i>
                                            </button>
                                        </div> 
                                        */}
                                    </ul>
                                </section>
                                <div className="tab-content" id="myTabContent" style={{ border: "none" }}>

                                    {/* -------------------------------------GENERAL--------------------------------------------------------- */}
                                    <div className={!!HideTotalCashCutsActions && HideTotalCashCutsActions === true ? "tab-pane fade" : "tab-pane fade active show"} id="general" role="tabpanel" aria-labelledby="general-tab">
                                        <div className="ml-5 mt-5 mr-5">
                                            <div id="accordion">
                                                <div className="">
                                                    <div className="cursor-pointer" data-toggle="collapse" data-target="#collapseOne" id="headingOne">
                                                        <table>
                                                            <tbody>
                                                                {CashCut.length > 0 &&
                                                                    CashCut.map((cashCut, index) => {
                                                                        if (cashCut.isHeader && ('Total cheque' === cashCut.Name)) {
                                                                            return (
                                                                                <tr id={`cashCut${index}`}>
                                                                                    <td>CHEQUES <i className="fa fa-angle-down" aria-hidden="true" /></td>
                                                                                    {blindCashCut ?
                                                                                        <td align="right">{CURRENCY + ` ${cashCut.Amount}`}</td>
                                                                                        :
                                                                                        <td align="right">{CURRENCY + ` ${Number(blindData.checksTotal).toFixed(2) || "0.00"}`}</td>
                                                                                    }
                                                                                </tr>
                                                                            )
                                                                        } else {
                                                                            return (<></>)
                                                                        }
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div id="collapseOne" className="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                                                        <div className="card-body scrollDivCut">
                                                            <table style={{ fontSize: "13px" }}>
                                                                <tbody>
                                                                    {CashCut.length > 0 &&
                                                                        CashCut.map((cashCut, index) => {
                                                                            if (!cashCut.isHeader && (this.findInName("CHEQUE", cashCut.Name))) {
                                                                                return (
                                                                                    <tr id={`cashCut${index}`}>
                                                                                        <td>{cashCut.Name.substring(7, 50)}</td>
                                                                                        {blindCashCut ?
                                                                                            <td align="right">{CURRENCY + ` ${Number(cashCut.Amount || 0.00).toFixed(2)}`}</td>
                                                                                            :
                                                                                            <td align="right">
                                                                                                <input
                                                                                                    type="number"
                                                                                                    min={0}
                                                                                                    className="text-right"
                                                                                                    style={{ minWidth: '8vh' }}
                                                                                                    value={blindData.checks[index] || 0.00}
                                                                                                    onChange={(event) => this.OnchangeChecks(event.target.value, index)}
                                                                                                />
                                                                                            </td>
                                                                                        }
                                                                                    </tr>
                                                                                )
                                                                            } else {
                                                                                return (<></>)
                                                                            }
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="">
                                                    <div className="cursor-pointer" data-toggle="collapse" data-target="#collapseTwo" id="headingTwo">
                                                        <table>
                                                            <tbody>
                                                                {CashCut.length > 0 &&
                                                                    CashCut.map((cashCut, index) => {
                                                                        if (cashCut.isHeader && ('Total tarjeta' == cashCut.Name)) {
                                                                            return (
                                                                                <tr id={`cashCut${index}`}>
                                                                                    <td>TARJETAS <i className="fa fa-angle-down" aria-hidden="true" /></td>
                                                                                    {blindCashCut ?
                                                                                        <td align="right">{CURRENCY + ` ${cashCut.Amount}`}</td>
                                                                                        :
                                                                                        <td align="right">{CURRENCY + ` ${Number(blindData.cardsTotal).toFixed(2) || "0.00"}`}</td>
                                                                                    }
                                                                                </tr>
                                                                            )
                                                                        } else {
                                                                            return (<></>)
                                                                        }
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                                        <div className="card-body scrollDivCut">
                                                            <table style={{ fontSize: "13px" }}>
                                                                <tbody>
                                                                    {CashCut.length > 0 &&
                                                                        CashCut.map((cashCut, index) => {
                                                                            if (!cashCut.isHeader && (this.findInName("TARJ", cashCut.Name))) {
                                                                                return (
                                                                                    <tr id={`cashCut${index}`}>
                                                                                        <td>{cashCut.Name ?? ''}</td>
                                                                                        {blindCashCut ?
                                                                                            <td align="right">{CURRENCY + ` ${Number(cashCut.Amount || 0.00).toFixed(2)}`}</td>
                                                                                            :
                                                                                            <td align="right">
                                                                                                <input
                                                                                                    type="number"
                                                                                                    min={0}
                                                                                                    placeholder='0.00'
                                                                                                    className="text-right"
                                                                                                    style={{ minWidth: '8vh' }}
                                                                                                    value={blindData.cards[index] || 0.00}
                                                                                                    onChange={(event) => this.OnchangeCards(event.target.value, index)}
                                                                                                />
                                                                                            </td>
                                                                                        }
                                                                                    </tr>
                                                                                )
                                                                            } else {
                                                                                return (<></>)
                                                                            }
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="">
                                                    <div className="cursor-pointer" data-toggle="collapse" data-target="#collapseThree" id="headingThree">
                                                        <table>
                                                            <tbody>
                                                                {CashCut.length > 0 &&
                                                                    CashCut.map((cashCut, index) => {
                                                                        if (cashCut.isHeader && ('Total transferencia' == cashCut.Name)) {
                                                                            return (
                                                                                <tr id={`cashCut${index}`}>
                                                                                    <td>TRANSFERENCIAS  <i className="fa fa-angle-down" aria-hidden="true" /></td>
                                                                                    {blindCashCut ?
                                                                                        <td align="right">{CURRENCY + ` ${cashCut.Amount}`}</td>
                                                                                        :
                                                                                        <td align="right">{CURRENCY + ` ${Number(blindData.transfersTotal).toFixed(2) || "0.00"}`}</td>
                                                                                    }
                                                                                </tr>
                                                                            )
                                                                        } else {
                                                                            return (<></>)
                                                                        }
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                                                        <div className="card-body scrollDivCut">
                                                            <table style={{ fontSize: "13px" }}>
                                                                <tbody>
                                                                    {CashCut.length > 0 &&
                                                                        CashCut.map((cashCut, index) => {
                                                                            if (!cashCut.isHeader && (this.findInName("TRANSF", cashCut.Name))) {
                                                                                return (
                                                                                    <tr id={`cashCut${index}`}>
                                                                                        {/* <td>{cashCut.Name.substring(8, 50)}</td> */}
                                                                                        <td>{this.transferName(cashCut.Name || '')}</td>
                                                                                        {blindCashCut ?
                                                                                            <td align="right">{CURRENCY + ` ${Number(cashCut.Amount || 0.00).toFixed(2)}`}</td>
                                                                                            :
                                                                                            <td align="right">
                                                                                                <input
                                                                                                    type="number"
                                                                                                    min={0}
                                                                                                    placeholder='0.00'
                                                                                                    className="text-right"
                                                                                                    style={{ minWidth: '8vh' }}
                                                                                                    value={blindData.transfers[index] || 0.00}
                                                                                                    onChange={(event) => this.OnchangeTransfers(event.target.value, index)}
                                                                                                />
                                                                                            </td>
                                                                                        }
                                                                                    </tr>
                                                                                )
                                                                            } else {
                                                                                return (<></>)
                                                                            }
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                        <div className="ml-5 mb-5 mr-5">
                                            <table>
                                                <tbody>
                                                    {CashCut.length > 0 &&
                                                        CashCut.map((cashCut, index) => {
                                                            if (cashCut.isHeader && ('Total devoluciones' == cashCut.Name)) {
                                                                return (
                                                                    <tr>
                                                                        <td>DEVOLUCIÓN COMO PAGO</td>
                                                                        <td align="right">{CURRENCY + ` ${Number(cashCut.Amount || 0.00).toFixed(2)}`}</td>
                                                                    </tr>
                                                                )
                                                            } else {
                                                                return (<></>)
                                                            }
                                                        })
                                                    }
                                                    {!!totalFISE &&
                                                        <tr>
                                                            <td>VALES FISE</td>
                                                            <td className="text-right">{CURRENCY + ` ${FORMAT_NUMBER.new(totalFISE)}`}</td>
                                                        </tr>
                                                    }
                                                    {!!totalQR &&
                                                        <tr>
                                                            <td>QR NIUBIZ</td>
                                                            <td className="text-right">{CURRENCY + ` ${FORMAT_NUMBER.new(totalQR)}`}</td>
                                                        </tr>
                                                    }
                                                    {CashCut.length > 0 &&
                                                        CashCut.map((cashCut, index) => {
                                                            if (!cashCut.isHeader && (!this.findInName("ENTRADA DE EFECTIVO", cashCut.Name) && !this.findInName("SALIDA EFECTIVO", cashCut.Name) && this.findInName("EFECTIVO", cashCut.Name))) {
                                                                return (
                                                                    <tr id={`cashCut${index}`}>
                                                                        <td>{cashCut.Name.toUpperCase()}</td>
                                                                        {blindCashCut ?
                                                                            <td align="right">{CURRENCY + ` ${Number(cashCut.Amount || 0.00).toFixed(2)}`}</td>
                                                                            :
                                                                            <td align="right">
                                                                                <input
                                                                                    type="number"
                                                                                    min={0}
                                                                                    placeholder='0.00'
                                                                                    className="text-right"
                                                                                    style={{ minWidth: '8vh' }}
                                                                                    value={blindData.cash || 0.00}
                                                                                    onChange={(event) => this.OnchangeCash(event.target.value)}
                                                                                />
                                                                            </td>
                                                                        }
                                                                    </tr>
                                                                )
                                                            } else {
                                                                return (<></>)
                                                            }
                                                        })
                                                    }

                                                </tbody>
                                                <tfoot>

                                                    {/* <tr>
                                                        <td>DEVOLUCIONES:</td>
                                                        {blindCashCut ?
                                                            <td align="right">{CURRENCY + ` ${Number(!!extraPaymentsCashCut ? extraPaymentsCashCut.negativeReturns : 0.00).toFixed(2)}`}</td>
                                                            :
                                                            <td align="right">
                                                                <input
                                                                    type="number"
                                                                    min={0}
                                                                    placeholder='0.00'
                                                                    className="text-right"
                                                                    style={{ minWidth: '8vh' }}
                                                                    value={blindData.returnsTotal || 0.00}
                                                                    onChange={(event) => this.OnchangeReturnsTotal(event.target.value)}
                                                                />
                                                            </td>
                                                        }
                                                    </tr> */}

                                                    {blindCashCut &&
                                                        <tr style={{ fontSize: 16 }}>
                                                            <td>TOTAL</td>
                                                            <td align="right">{CURRENCY + ` ${Number(TotalCashCut).toFixed(2)}`}</td>
                                                        </tr>
                                                    }
                                                </tfoot>
                                            </table>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary" data-dismiss={lastDaySession ? '' : `modal`} onClick={lastDaySession ? () => { } : ShowCashCutModal}>Cerrar</button>

                                            <button className="btn btn-primary" onClick={() => this.PrintCashCut("Corte", "80", _user, CashCut, 0)}>
                                                <i className="fa fa-print ml-2 mr-2" aria-hidden="true" />Imprimir
                                            </button>
                                        </div>
                                    </div>
                                    {/* ------------------------------------- VENTAS --------------------------------------------------------- */}
                                    <div className={!!HideTotalCashCutsActions && HideTotalCashCutsActions === true ? "tab-pane fade active show" : "tab-pane fade"} id="ventas" role="tabpanel" aria-labelledby="ventas-tab">

                                        <div className="ml-5 mt-5 mr-5">
                                            <div id="accordionV">
                                                <div className="">
                                                    <div className="cursor-pointer" data-toggle="collapse" data-target="#collapseOneV" id="headingOneV" onClick={() => this.IsOpen("collapseOneV", "headingOneV")}>
                                                        <table>
                                                            <tbody>
                                                                {CashCut.length > 0 &&
                                                                    CashCut.map((cashCut, index) => {
                                                                        if (cashCut.isHeader && ('Total cheque' === cashCut.Name)) {
                                                                            return (
                                                                                <tr id={`cashCut${index}`}>
                                                                                    <td>CHEQUES <i className="fa fa-angle-down" aria-hidden="true" /></td>
                                                                                    {!blindCashCut ?
                                                                                        <td align="right">{CURRENCY + ` ${cashCut.Amount}`}</td>
                                                                                        :
                                                                                        <td align="right">{CURRENCY + ` ${Number(blindData.checksTotal).toFixed(2) || "0.00"}`}</td>
                                                                                    }
                                                                                </tr>
                                                                            )
                                                                        } else {
                                                                            return (<></>)
                                                                        }
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div id="collapseOneV" className="collapse" aria-labelledby="headingOneV" data-parent="#accordionV">
                                                        <div className="card-body scrollDivCut">
                                                            <table style={{ fontSize: "13px" }}>
                                                                <tbody>
                                                                    {!blindCashCut ?
                                                                        CashCut.length > 0 &&
                                                                        CashCut.map((cashCut, index) => {
                                                                            if (cashCut.isHeader && ('Total cheque' === cashCut.Name)) {
                                                                                return (
                                                                                    <tr id={`cashCut${index}`}>
                                                                                        <td>CHEQUES <i className="fa fa-angle-down" aria-hidden="true" /></td>
                                                                                        <td align="right">{CURRENCY + ` ${cashCut.Amount}`}</td>
                                                                                    </tr>
                                                                                )
                                                                            } else {
                                                                                return (<></>)
                                                                            }
                                                                        })

                                                                        :
                                                                        blindData.checks && blindData.checks.length > 0 &&
                                                                        blindData.checks.map((check, index) => {
                                                                            return (
                                                                                <>
                                                                                    <tr id={`cashCut${index}`}>
                                                                                        <td>{check.Name ?? ''}</td>
                                                                                        <td align="right">
                                                                                            <input
                                                                                                type="number"
                                                                                                min={0}
                                                                                                placeholder='0.00'
                                                                                                className="text-right"
                                                                                                style={{ minWidth: '8vh' }}
                                                                                                value={check.Amount || ""}
                                                                                                onChange={(event) => this.OnchangeChecks(event.target.value, index)}
                                                                                            />
                                                                                        </td>
                                                                                    </tr>
                                                                                </>
                                                                            )
                                                                        })

                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="">
                                                    <div className="cursor-pointer" data-toggle="collapse" data-target="#collapseTwoV" id="headingTwoV" onClick={() => this.IsOpen("collapseTwoV", "headingTwoV")}>
                                                        <table>
                                                            <tbody>
                                                                {CashCut.length > 0 &&
                                                                    CashCut.map((cashCut, index) => {
                                                                        if (cashCut.isHeader && ('Total tarjeta' == cashCut.Name)) {
                                                                            return (
                                                                                <tr id={`cashCut${index}`}>
                                                                                    <td>TARJETAS <i className="fa fa-angle-down" aria-hidden="true" /></td>
                                                                                    {!blindCashCut ?
                                                                                        <td align="right">{CURRENCY + ` ${cashCut.Amount}`}</td>
                                                                                        :
                                                                                        <td align="right">{CURRENCY + ` ${Number(blindData.cardsTotal).toFixed(2) || "0.00"}`}</td>
                                                                                    }
                                                                                </tr>
                                                                            )
                                                                        } else {
                                                                            return (<></>)
                                                                        }
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div id="collapseTwoV" className="collapse" aria-labelledby="headingTwoV" data-parent="#accordionV">
                                                        <div className="card-body scrollDivCut">
                                                            <table style={{ fontSize: "13px" }}>
                                                                <tbody>
                                                                    {!blindCashCut ?
                                                                        CashCut.length > 0 &&
                                                                        CashCut.map((cashCut, index) => {
                                                                            if (!cashCut.isHeader && (this.findInName("TARJ", cashCut.Name))) {
                                                                                return (
                                                                                    <tr id={`cashCut${index}`}>
                                                                                        <td>{cashCut.Name}</td>
                                                                                        <td align="right">{CURRENCY + ` ${Number(cashCut.Amount || 0.00).toFixed(2)}`}</td>
                                                                                    </tr>
                                                                                )
                                                                            } else {
                                                                                return (<></>)
                                                                            }
                                                                        })
                                                                        :
                                                                        blindData.cards && blindData.cards.length > 0 &&
                                                                        blindData.cards.map((card, index) => {
                                                                            return (
                                                                                <>
                                                                                    <tr id={`cashCut${index}`}>
                                                                                        <td>{card.Name ?? ''}</td>


                                                                                        <td align="right">
                                                                                            <input
                                                                                                type="number"
                                                                                                min={0}
                                                                                                placeholder='0.00'
                                                                                                className="text-right"
                                                                                                style={{ minWidth: '8vh' }}
                                                                                                value={card.Amount || ""}
                                                                                                onChange={(event) => this.OnchangeCards(event.target.value, index)}
                                                                                            />
                                                                                        </td>

                                                                                    </tr>
                                                                                </>
                                                                            )
                                                                        })
                                                                    }

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="">
                                                    <div className="cursor-pointer" data-toggle="collapse" data-target="#collapseThreeV" id="headingThreeV" onClick={() => this.IsOpen("collapseThreeV", "headingThreeV")}>
                                                        <table>
                                                            <tbody>

                                                                {CashCut.length > 0 &&
                                                                    CashCut.map((cashCut, index) => {
                                                                        if (cashCut.isHeader && ('Total transferencia' == cashCut.Name)) {
                                                                            return (
                                                                                <tr id={`cashCut${index}`}>
                                                                                    <td>TRANSFERENCIAS <i className="fa fa-angle-down" aria-hidden="true" /></td>
                                                                                    {!blindCashCut ?
                                                                                        <td align="right">{CURRENCY + ` ${cashCut.Amount}`}</td>
                                                                                        :
                                                                                        <td align="right">{CURRENCY + ` ${Number(blindData.transfersTotal).toFixed(2) || "0.00"}`}</td>
                                                                                    }
                                                                                </tr>
                                                                            )
                                                                        } else {
                                                                            return (<></>)
                                                                        }
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div id="collapseThreeV" className="collapse" aria-labelledby="headingThreeV" data-parent="#accordionV">
                                                        <div className="card-body scrollDivCut">
                                                            <table style={{ fontSize: "13px" }}>
                                                                <tbody>
                                                                    {!blindCashCut ?
                                                                        CashCut.length > 0 &&
                                                                        CashCut.map((cashCut, index) => {
                                                                            if (!cashCut.isHeader && (this.findInName("TRANSF", cashCut.Name))) {
                                                                                return (
                                                                                    <tr id={`cashCut${index}`}>
                                                                                        <td>{cashCut.Name.substring(8, 50)}</td>
                                                                                        <td align="right">{CURRENCY + ` ${Number(cashCut.Amount || 0.00).toFixed(2)}`}</td>
                                                                                    </tr>
                                                                                )
                                                                            } else {
                                                                                return (<></>)
                                                                            }
                                                                        })
                                                                        :
                                                                        blindData.transfers && blindData.transfers.length > 0 &&
                                                                        blindData.transfers.map((transfer, index) => {
                                                                            return (
                                                                                <>
                                                                                    <tr id={`cashCut${index}`}>
                                                                                        <td>{transfer.Name ?? ''}</td>
                                                                                        <td align="right">
                                                                                            <input
                                                                                                type="number"
                                                                                                min={0}
                                                                                                placeholder='0.00'
                                                                                                className="text-right"
                                                                                                style={{ minWidth: '8vh' }}
                                                                                                value={transfer.Amount || ""}
                                                                                                onChange={(event) => this.OnchangeTransfers(event.target.value, index)}
                                                                                            />
                                                                                        </td>
                                                                                    </tr>
                                                                                </>
                                                                            )
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div className="ml-5 mb-5 mr-5">
                                            <table>
                                                <tbody>

                                                    {CashCut.length > 0 &&
                                                        CashCut.map((cashCut, index) => {
                                                            if (cashCut.isHeader && ('Total devoluciones' == cashCut.Name)) {
                                                                return (
                                                                    <tr>
                                                                        <td>DEVOLUCIÓN COMO PAGO</td>
                                                                        {!blindCashCut ?
                                                                            <td align="right">{CURRENCY + ` ${Number(cashCut.Amount || 0.00).toFixed(2)}`}</td>
                                                                            :
                                                                            <td align="right">
                                                                                <input
                                                                                    type="number"
                                                                                    min={0}
                                                                                    placeholder='0.00'
                                                                                    className="text-right"
                                                                                    style={{ minWidth: '8vh' }}
                                                                                    value={blindData.returnsAPTotal.Amount || ""}
                                                                                    onChange={(event) => this.OnchangeReturnsAP(event.target.value)}
                                                                                />
                                                                            </td>
                                                                        }
                                                                    </tr>
                                                                )
                                                            } else {
                                                                return (<></>)
                                                            }
                                                        })
                                                    }
                                                    {!!totalFISE &&
                                                        <tr>
                                                            <td>VALES FISE</td>
                                                            {!blindCashCut ? <td className="text-right">{CURRENCY + ` ${FORMAT_NUMBER.new(totalFISE)}`}</td>
                                                                :
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        min={0}
                                                                        placeholder='0.00'
                                                                        className="text-right"
                                                                        style={{ minWidth: '8vh' }} />
                                                                </td>
                                                            }
                                                        </tr>
                                                    }
                                                    {!!totalQR &&
                                                        <tr>
                                                            <td>QR NIUBIZ</td>
                                                            {!blindCashCut ? <td className="text-right">{CURRENCY + ` ${FORMAT_NUMBER.new(totalQR)}`}</td>
                                                                :
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        min={0}
                                                                        placeholder='0.00'
                                                                        className="text-right"
                                                                        style={{ minWidth: '8vh' }} />
                                                                </td>
                                                            }
                                                        </tr>
                                                    }
                                                    {CashCut.length > 0 &&
                                                        CashCut.map((cashCut, index) => {
                                                            if (!cashCut.isHeader && (!this.findInName("ENTRADA DE EFECTIVO", cashCut.Name) && !this.findInName("SALIDA EFECTIVO", cashCut.Name) && this.findInName("EFECTIVO", cashCut.Name))) {
                                                                return (
                                                                    <tr id={`cashCut${index}`}>
                                                                        <td>{cashCut.Name.toUpperCase()}</td>
                                                                        {!blindCashCut ?
                                                                            <td align="right">{CURRENCY + ` ${Number(cashCut.Amount || 0.00).toFixed(2)}`}</td>
                                                                            :
                                                                            <td align="right">
                                                                                <input
                                                                                    type="number"
                                                                                    min={0}
                                                                                    placeholder='0.00'
                                                                                    className="text-right"
                                                                                    style={{ minWidth: '8vh' }}
                                                                                    value={blindData.cash.Amount || ""}
                                                                                    onChange={(event) => this.OnchangeCash(event.target.value)}
                                                                                />
                                                                            </td>
                                                                        }
                                                                    </tr>
                                                                )
                                                            } else {
                                                                return (<></>)
                                                            }
                                                        })
                                                    }

                                                </tbody>
                                                <tfoot>

                                                    {/* <tr>
                                                        <td>DEVOLUCIONES: </td>
                                                        {!blindCashCut ?
                                                            <td align="right">{CURRENCY + ` ${Number(!!extraPaymentsCashCut ? extraPaymentsCashCut.negativeReturns : 0.00).toFixed(2)}`}</td>
                                                            :
                                                            <td align="right">
                                                                <input
                                                                    type="number"
                                                                    min={0}
                                                                    placeholder='0.00'
                                                                    className="text-right"
                                                                    style={{ minWidth: '8vh' }}
                                                                    value={blindData.returns.Amount || ""}
                                                                    onChange={(event) => this.OnchangeReturnsTotal(event.target.value)}
                                                                />
                                                            </td>
                                                        }
                                                    </tr> */}


                                                    {!blindCashCut &&
                                                        <tr style={{ fontSize: 16 }}>
                                                            <td>TOTAL</td>
                                                            <td align="right">{CURRENCY + ` ${TotalCashCut ? Number(TotalCashCut).toFixed(2) : 0}`}</td>
                                                        </tr>
                                                    }
                                                </tfoot>
                                            </table>
                                        </div>
                                        <div className="modal-footer">
                                            {!!HideTotalCashCutsActions && HideTotalCashCutsActions === true ?
                                                <>
                                                    <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={lastDaySession ? () => { } : ShowCashCutModal}>Cerrar</button>
                                                    {/* <button type="button" className="btn btn-success">Guardar</button> */}
                                                    <button className="btn btn-primary" onClick={() => this.PrintCashCut("Corte", "80", _user, CashCut, 3)}>
                                                        <i className="fa fa-print ml-2 mr-2" aria-hidden="true" />Imprimir
                                                    </button>
                                                </>
                                                :
                                                <>
                                                    <button type="button" className="btn btn-danger" data-dismiss={lastDaySession ? `` : 'modal'} onClick={lastDaySession ? () => { } : ShowCashCutModal}>Cancelar</button>
                                                    {/* <button type="button" className="btn btn-success">Guardar</button> */}
                                                    <button className="btn counterbtn" style={{ backgroundColor: '#278b48', borderColor: '#278b48', color: 'white' }} onClick={this.HandleRealizar}>
                                                        <i className="fa fa-scissors ml-2 mr-2" />Realizar
                                                    </button>
                                                </>

                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ValidationModal
                    idValidation="vmCashCut"
                    message={this.state.cashCutConfirmationMessage}
                    idModalOrigin="#cashCutModal"
                    // idModalDestiny="#totalModal"
                    eventOnclick={this.ConfirmCashCutAction} />


                <div className="modal fade" id="totalModal" role="dialog" tabIndex="-1" aria-labelledby="totalModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content" style={{ backgroundColor: "#fff0", border: "none" }}>
                            <div className="modal-body">
                                <div className="ticket" style={{ fontSize: 12 }}>
                                    <div className="m-3">
                                        <div className="" >
                                            <div className="text-center" >
                                                <img className="img-fluid d-block mx-auto" src={require('../images/logoTicket.png')} style={{ maxWidth: "200px" }} alt=""></img>
                                                <p>{`SUCURSAL: ${_user?.Sucursal.toUpperCase()} `}</p>
                                                <p>{_user?.Branch?.Address.toUpperCase()}</p>
                                            </div>
                                            <div className='text-center'>
                                                <span><strong>CORTE TOTAL</strong></span>
                                            </div>
                                            <br />
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td align="left">FECHA: </td>
                                                        <td align="right">{moment(headerCashCut.docUpdate || new Date()).format('DD-MM-YYYY') + "  " + (headerCashCut.endSession !== '' ? moment(headerCashCut.endSession).add(6, "hours").format('LTS') : moment(new Date()).format('LTS')) || ""}</td>
                                                    </tr>
                                                    <tr>
                                                        <td align="left">USUARIO: </td>
                                                        <td align="right">{headerCashCut.U_NAME || user.USER_CODE || ""}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <table>
                                            <tbody>
                                                <br />
                                                {CashCut.length > 0 &&
                                                    CashCut.map((cashCut, index) => {
                                                        if (cashCut.isHeader && ('Total cheque' == cashCut.Name)) {
                                                            return (
                                                                <tr id={`cashCut${index}`}>
                                                                    <td>CHEQUES</td>
                                                                    <td align="right">{CURRENCY + ` ${cashCut.Amount}`}</td>
                                                                </tr>
                                                            )
                                                        } else {
                                                            return (<></>)
                                                        }
                                                    })
                                                }
                                                {CashCut.length > 0 &&
                                                    CashCut.map((cashCut, index) => {
                                                        if (cashCut.isHeader && ('Total tarjeta' == cashCut.Name)) {
                                                            return (
                                                                <tr id={`cashCut${index}`}>
                                                                    <td>TARJETAS</td>
                                                                    <td align="right">{CURRENCY + ` ${cashCut.Amount}`}</td>
                                                                </tr>
                                                            )
                                                        } else {
                                                            return (<></>)
                                                        }
                                                    })
                                                }
                                                {CashCut.length > 0 &&
                                                    CashCut.map((cashCut, index) => {
                                                        if (cashCut.isHeader && ('Total transferencia' == cashCut.Name)) {
                                                            return (
                                                                <tr id={`cashCut${index}`}>
                                                                    <td>TRANSFERENCIAS</td>
                                                                    <td align="right">{CURRENCY + ` ${cashCut.Amount}`}</td>
                                                                </tr>
                                                            )
                                                        } else {
                                                            return (<></>)
                                                        }
                                                    })
                                                }
                                                {CashCut.length > 0 &&
                                                    CashCut.map((cashCut, index) => {
                                                        if (cashCut.isHeader && ('Total devoluciones' == cashCut.Name)) {
                                                            return (
                                                                <tr id={`cashCut${index}`}>
                                                                    <td>DEVOLUCIÓN COMO PAGO</td>
                                                                    <td align="right">{CURRENCY + ` ${cashCut.Amount}`}</td>
                                                                </tr>
                                                            )
                                                        } else {
                                                            return (<></>)
                                                        }
                                                    })
                                                }
                                                {!!totalFISE &&
                                                    <tr id="cashCut-totalFISE">
                                                        <td>VALES FISE</td>
                                                        <td align="right">{`${CURRENCY} ${FORMAT_NUMBER.new(totalFISE)}`}</td>
                                                    </tr>
                                                }

                                                {!!totalQR &&
                                                    <tr id="cashCut-totalQR">
                                                        <td>QR NIUBIZ</td>
                                                        <td align="right">{`${CURRENCY} ${FORMAT_NUMBER.new(totalQR)}`}</td>
                                                    </tr>
                                                }
                                                {CashCut.length > 0 &&
                                                    CashCut.map((cashCut, index) => {
                                                        if (!cashCut.isHeader && (!this.findInName("ENTRADA DE EFECTIVO", cashCut.Name) && !this.findInName("SALIDA EFECTIVO", cashCut.Name) && this.findInName("EFECTIVO", cashCut.Name))) {
                                                            return (
                                                                <tr id={`cashCut${index}`}>
                                                                    <td>{cashCut.Name.toUpperCase()}</td>
                                                                    <td align="right">{CURRENCY + ` ${Number(cashCut.Amount || 0.00).toFixed(2)}`}</td>
                                                                </tr>
                                                            )
                                                        } else {
                                                            return (<></>)
                                                        }
                                                    })
                                                }
                                                {/* <tr>
                                                    <td>ENTRADAS DE DINERO</td>
                                                    <td align="right">{CURRENCY + ` ${Number(!!moneyEntries.total ? moneyEntries.total : 0.00).toFixed(2)}`}</td>
                                                </tr> */}
                                                {/* <tr>
                                                    <td>SALIDAS DE DINERO</td>
                                                    <td align="right">{CURRENCY + ` ${Number(!!moneyOuts.total ? moneyOuts.total : 0.00).toFixed(2)}`}</td>
                                                </tr> */}
                                                {/* <tr>
                                                    <td>CREDITO</td>
                                                    <td align="right">{CURRENCY + ` ${Number(!!extraPaymentsCashCut ? extraPaymentsCashCut.credit : 0.00).toFixed(2)}`}</td>
                                                </tr>
                                                <tr>
                                                    <td>NOTAS DE CREDITO</td>
                                                    <td align="right">{CURRENCY + ` ${Number(!!extraPaymentsCashCut ? extraPaymentsCashCut.creditNotes : 0.00).toFixed(2)}`}</td>
                                                </tr> */}
                                            </tbody>
                                            <br /><br /><br /><br /><br /><br /><br />
                                            <tfoot>
                                                {/* <tr>
                                                    <td>{`VENTAS: ${NumVentas}`}</td>
                                                    <td align="right">{CURRENCY + ` ${Number(TotalAmountSales || 0.00).toFixed(2)}`}</td>
                                                </tr> */}
                                                {/* <tr>
                                                    <td>DEVOLUCIONES: {`${ObjCharge.TotalCharges || ""}`}</td>
                                                    <td align="right">{CURRENCY + ` ${Number(!!extraPaymentsCashCut ? extraPaymentsCashCut.negativeReturns : 0.00).toFixed(2)}`}</td>
                                                </tr> */}
                                                {/* <tr>
                                                    <td>COBRANZA: {`${ObjCharge.TotalCharges || ""}`}</td>
                                                    <td align="right">{CURRENCY + ` ${Number(ObjCharge.Charge || 0.00).toFixed(2)}`}</td>
                                                </tr> */}
                                                {/* <tr>
                                                    <td>ENTRADAS Y SALIDAS: </td>
                                                    <td align="right">{CURRENCY + ` ${(Number(moneyEntries.total) - Number(moneyOuts.total)).toFixed(2)}`}</td>
                                                </tr> */}
                                                <tr style={{ fontSize: 16 }}>
                                                    <td>TOTAL</td>
                                                    <td align="right">{CURRENCY + ` ${Number(TotalCashCut).toFixed(2)}`}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <br />
                                    <div className="text-right" style={{ marginTop: "-13px" }}>
                                        <button className="btn" onClick={() => this.PrintCashCut("Corte", "80", _user, CashCut, 1)}><i className="fa fa-print" aria-hidden="true" style={{ fontSize: "20px", color: "#80808073" }}></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {this.props.showDepositOperations !== false && !!currentCashCut && (
                    <AppsCashCuts
                        type={0} // 0: COUNTER, 1: APPS
                        cashCut={currentCashCut}
                        cancel={() => { }}
                        bankOptions={bankOptions}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        enableSpinner: (value) => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CashCutModal);